"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.depositPieceRole = void 0;
const usage_1 = require("./usage");
/**
 * What each document IS, in the commercial's terms.
 *
 * Keyed on usage rather than filename: `cerfa_PC_13406-15.pdf` and
 * `matrix.pdf` name the artifact, not the errand, and the errand is what the
 * reader is here for.
 */
const ROLE = {
    // The proof the deposit happened, and the document the instruction clock is
    // read from — it leads the row once it exists, in the one tone nothing else
    // here uses.
    receipt: {
        title: 'Récépissé de dépôt',
        role: 'La preuve que la mairie a bien reçu le dossier, et le point de départ du délai d’instruction.',
        icon: 'check',
        tone: 'green',
    },
    cerfa: {
        title: 'Formulaire Cerfa',
        role: 'La demande officielle. C’est la pièce que le client doit signer.',
        icon: 'paper',
        tone: 'blue',
    },
    // Only exists when the dossier has more than one declarant, hence "if
    // available" — it is generated with the CERFA and wiped with it on `accept`.
    otherApplicants: {
        title: 'Fiche des autres demandeurs',
        role: 'L’annexe au Cerfa qui liste les co-demandeurs. Chacun doit la signer.',
        icon: 'user',
        tone: 'blue',
    },
    matrix: {
        title: 'Matrice — les plans',
        role: 'Plan de situation, masse, coupes, façades et insertion, réunis dans un seul document.',
        icon: 'image',
        tone: 'violet',
    },
    other: {
        title: 'Pièce du dossier',
        role: 'À joindre au dépôt.',
        icon: 'folder',
        tone: 'blue',
    },
};
/**
 * Each usage of the sent dossier, named explicitly — including the legacy CERFA
 * identifiers — so a new usage is a deliberate entry here rather than something
 * a prefix happens to catch.
 */
const ROLE_BY_USAGE = {
    [usage_1.ProjectFileUsage.DEPOSIT_RECEIPT]: ROLE.receipt,
    [usage_1.ProjectFileUsage.CERFA_DP]: ROLE.cerfa,
    [usage_1.ProjectFileUsage.CERFA_PC]: ROLE.cerfa,
    [usage_1.ProjectFileUsage.CERFA_PCM]: ROLE.cerfa,
    [usage_1.ProjectFileUsage.CERFA_13703_11]: ROLE.cerfa,
    [usage_1.ProjectFileUsage.CERFA_13406_12]: ROLE.cerfa,
    [usage_1.ProjectFileUsage.CERFA_13411_11]: ROLE.cerfa,
    [usage_1.ProjectFileUsage.OTHER_APPLICANTS_SHEET]: ROLE.otherApplicants,
    [usage_1.ProjectFileUsage.PC_MATRIX]: ROLE.matrix,
    [usage_1.ProjectFileUsage.DP_MATRIX]: ROLE.matrix,
};
/** What a piece of the dossier is, named for the commercial, by its usage. */
const depositPieceRole = (usage) => ROLE_BY_USAGE[usage] ?? ROLE.other;
exports.depositPieceRole = depositPieceRole;
//# sourceMappingURL=deposit-roles.js.map